import { Navigate } from "react-router-dom";
import { getPageRoute } from "src/services";

export function HandleRedirect() {
  const params = new URLSearchParams(window.location.search);
  const calendarUrl = params.get("calendar");
  
  if (calendarUrl) {
    try {
      const decoded = decodeURIComponent(calendarUrl);
      const match = decoded.match(/schedules\/([^/?#&]+)/);
      if (match?.[1]) {
        return <Navigate to={getPageRoute("calendar", "ALL_EVENTS", { handle: match[1] })} />;
      }
    } catch (e) {
      console.error("Redirect error:", e);
    }
  }
  return <Navigate to="/" state={{ calendarNotFound: true }} />;
} 